module.exports = __webpack_public_path__ + "img/gjx.a0e551cb.png";